import { formatUsd, formatUsdWhole } from '@/lib/format'
import { Flash } from './flash'

/**
 * A card header's flow buttons (Holdings: Swap, Deposit, Withdraw; Kraken: Sell, Withdraw): a 36px square around a
 * 20px icon until the words fit beside the figure (lg, with the sidebar open), then the button's own padding, the
 * 16px icon and the word (John, Nov 3 2026: the icon view must be square, not the button's taller padding;
 * Nov 4: the phone icons went from 16px to 20px, "slightly bigger"; 40px squares made the Holdings row, 320px wide
 * inside on his phone, 6px too long and the buttons wrapped under the total). Icons take HEADER_ICON for the same step.
 */
export const HEADER_BTN = 'btn shrink-0 p-2 lg:px-4 lg:py-2.5'
export const HEADER_ICON = 'size-5 lg:size-4'

/**
 * A card header's dollar total, after the title and its divider (John, Nov 3 2026: "Holdings | $27,623.45").
 * Phones get whole dollars: with the cents, the Holdings row (total, three icon buttons, the filter) ran past a 390px
 * screen and wrapped; from sm up the cents are back.
 */
export function CardFigure({ usd }: { usd: number | null | undefined }) {
  return (
    <span className="card-figure">
      {/* a total that moved since the last poll tints for a moment, like the holdings rows (Nov 4 2026, flash.tsx) */}
      <span className="sm:hidden"><Flash value={usd} text={formatUsdWhole(usd)} /></span>
      <span className="hidden sm:inline"><Flash value={usd} text={formatUsd(usd)} /></span>
    </span>
  )
}
